import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';
import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionDefinition,OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { isMyCollectionsSubspace,SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

export const defaultCollectionSort = [Order.asc(OrderKeys.name)];

const permissionedItemCountOption: OptionDefinition = {
  id: 'permissionedItemCount',
  getMenuItemDisplayValue: Messages.collectionItemCountColumn,
  subSortOptions: {
    'desc': {
      id: 'permissionedItemCount.desc',
      field: OrderKeys.permissionedItemCount,
      getMenuItemDisplayValue: Messages.sortByMostLeast,
      getButtonDisplayValue: Messages.sortByItemsDesc,
      ascending: false,
      toOrderClauseArray: () => [Order.desc(OrderKeys.permissionedItemCount)]
    },
    'asc': {
      id: 'permissionedItemCount.asc',
      field: OrderKeys.permissionedItemCount,
      getMenuItemDisplayValue: Messages.sortByLeastMost,
      getButtonDisplayValue: Messages.sortByItemsAsc,
      ascending: true,
      toOrderClauseArray: () => [Order.asc(OrderKeys.permissionedItemCount)]
    }
  }
};

export function getCollectionsSortOptions(spaceInfo: SpaceInfo) {
  if (isMyCollectionsSubspace(spaceInfo)) {
    return _.omit(collectionsSortOptions, 'owner');
  }
  return collectionsSortOptions;
}

export const collectionsSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'owner': SortOptions.owner,
  'permissionedItemCount': permissionedItemCountOption,
  'createdTime': SortOptions.createdTime,
  'updatedTime': SortOptions.updatedTime,
};
